import moment from 'moment';

class Historie {

    public entityType: string;
    public entityID: number;
    public name: string;
    public date: Date;
    public user: string;
    public childRecords: Historie[] = [];

    public clone(): Historie {
        const newHistorie: Historie = new Historie();
        newHistorie.loadFromEntity(this);
        return newHistorie;
    }

    public loadFromJSON(json: any): Historie {
        this.entityType = json.entity_type;
        this.entityID = json.entity_id;
        this.date = moment(json.date).toDate();
        this.name = json.name;
        this.user = json.user;

        json.child_records.forEach(item => {
            const childItem: Historie = new Historie();
            childItem.loadFromJSON(item);
            this.childRecords.push(childItem);
        });

        return this;
    }

    public loadFromEntity(ent: Historie): Historie {
        this.entityType = ent.entityType;
        this.entityID = ent.entityID;
        this.date = ent.date;
        this.name = ent.name;
        this.user = ent.user;
        this.childRecords = ent.childRecords;
        return this;
    }

}

export default Historie;


// WEBPACK FOOTER //
// ./src/models/Historie.tsx